<template>
    <div>
        <div v-if="variantGroups.length > 0" class="row">
            <template v-for="(variantGroup, variantGroupIndex) in variantGroups">
                <div
                    v-if="variantGroup.options.length > 1"
                    :key="variantGroupIndex"
                    class="col-12 variant-dropdown--large mb-1"
                    :class="['select'].includes(variantGroup.type) && moreSelect ? 'col-xl-6' : ''"
                >
                    <div
                        class="fs-15 fwb variant-dropdown__title mb-2"
                        :class="variantGroup.type === 'select' ? 'variant-dropdown__title--show' : 'variant-dropdown__title--normal'"
                    >
                        {{ variantGroup.name }}
                    </div>

                    <template v-if="variantGroup.type === 'image'">
                        <nuxt-link
                            v-for="(variant, index) in variantGroup.options"
                            :key="index"
                            :to="variant.url"
                            class="tdn"
                            :title="variant.name"
                            @click="triggerSelectItemEvent(variant, index)"
                        >
                            <img
                                v-lazy-load
                                src="/nuxt-assets/images/lazy-load-error.svg"
                                :data-src="variant.image"
                                :alt="variant.name"
                                class="variant-image"
                                :class="{
                                    'variant-image--active': variant.isActive,
                                    'tippy-tooltip js-tooltip': variant.isAvailable,
                                }"
                            />
                        </nuxt-link>
                    </template>
                    <template
                        v-else-if="
                            variantGroup.type === 'radio' || (variantGroup.type === 'radioSelectFrom4' && variantGroup.options.length <= 3)
                        "
                    >
                        <div class="d-flex flex-wrap">
                            <nuxt-link
                                v-for="(variant, index) in variantGroup.options"
                                :key="index"
                                :to="variant.url"
                                class="variant-radio"
                                :class="{ 'variant-radio--active': variant.isActive }"
                                @click="triggerSelectItemEvent(variant, index)"
                            >
                                <span v-if="!variant.isAvailable" style="text-decoration: line-through">
                                    {{ variant.name }}
                                </span>
                                <template v-else>{{ variant.name }}</template>
                            </nuxt-link>
                        </div>
                    </template>
                    <template v-else-if="variantGroup.type === 'selectImage'">
                        <div class="variant-dropdown js-variant-dropdown">
                            <template v-for="(variant, index) in variantGroup.options" :key="index">
                                <div
                                    v-if="index === 0"
                                    class="pl-0 variant-dropdown__trigger row align-items-center g-0 cursor-point"
                                    @click="openDropdown"
                                >
                                    <div class="col-3 d-flex justify-content-center">
                                        <img
                                            v-lazy-load
                                            src="/nuxt-assets/images/lazy-load-error.svg"
                                            :data-src="variant.image"
                                            :alt="variant.name"
                                            class="variant-dropdown__image"
                                        />
                                    </div>
                                    <div class="col-7">
                                        {{ variant.name }}
                                    </div>
                                    <div class="col-2 text-right">
                                        <i class="ico-arrow"></i>
                                    </div>
                                </div>
                            </template>

                            <div class="variant-dropdown__container vertical-scrollbar js-variant-dropdown-container">
                                <template v-for="(variant, index) in variantGroup.options" :key="index">
                                    <nuxt-link
                                        class="pl-0 variant-dropdown__item row g-0 align-items-center"
                                        :class="{ 'variant-dropdown__item--active': index === 0 }"
                                        :to="variant.url"
                                        @click="triggerSelectItemEvent(variant, index)"
                                    >
                                        <div class="col-3 d-flex justify-content-center">
                                            <img
                                                v-lazy-load
                                                src="/nuxt-assets/images/lazy-load-error.svg"
                                                :data-src="variant.image"
                                                :alt="variant.name"
                                                class="variant-dropdown__image"
                                            />
                                        </div>
                                        <div class="col-5 lh-19">
                                            <span v-if="variant.isInStock">
                                                {{ variant.name }}
                                                <span class="text-green-dark d-block" v-html="variant.availabilityText"></span>
                                            </span>
                                            <span v-else-if="variant.isNoWarehouse" style="text-decoration: line-through">
                                                {{ variant.name }}
                                                <span class="text-danger d-block" v-html="variant.availabilityText"></span>
                                            </span>
                                            <span v-else-if="!variant.isAvailable" style="text-decoration: line-through">
                                                {{ variant.name }}
                                                <span class="text-green-dark d-block" v-html="variant.availabilityText"></span>
                                            </span>
                                            <template v-else>
                                                {{ variant.name }}
                                                <span class="text-warning d-block" v-html="variant.availabilityText"></span>
                                            </template>
                                        </div>
                                        <div class="col-2">
                                            <div
                                                v-if="variant.percentDiscount"
                                                class="badge badge-products badge-sale text-uppercase text-dark d-inline text-center px-1 fs-12 fwb d-block ml-xl-0 text-nowrap"
                                            >
                                                -{{ variant.percentDiscount }}%
                                            </div>
                                        </div>
                                        <div class="col-2 text-right text-nowrap notranslate" v-html="$formatCurrency(variant.price)" />
                                    </nuxt-link>
                                </template>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="variant-dropdown js-variant-dropdown">
                            <template v-for="(variant, index) in variantGroup.options" :key="index">
                                <div
                                    v-if="index === 0"
                                    class="variant-dropdown__trigger row align-items-center g-0 cursor-point"
                                    @click="openDropdown"
                                >
                                    <div class="col-8">
                                        {{ variant.name }}
                                    </div>
                                    <div class="col-4 text-right">
                                        <i class="ico-arrow"></i>
                                    </div>
                                </div>
                            </template>

                            <div
                                class="variant-dropdown__container vertical-scrollbar js-variant-dropdown-container"
                                :class="variantGroup.options.length > 3 ? 'variant-dropdown__container--scroll' : ''"
                            >
                                <nuxt-link
                                    v-for="(variant, index2) in variantGroup.options"
                                    :key="index2"
                                    class="variant-dropdown__item row g-0 align-items-center"
                                    :class="{ 'variant-dropdown__item--active': index2 === 0 }"
                                    :to="variant.url"
                                    @click="triggerSelectItemEvent(variant, index2)"
                                >
                                    <div class="col-7 lh-19">
                                        <span v-if="variant.isInStock">
                                            {{ variant.name }}
                                            <span class="text-green-dark d-block" v-html="variant.availabilityText"></span>
                                        </span>
                                        <span v-else-if="variant.isNoWarehouse" style="text-decoration: line-through">
                                            {{ variant.name }}
                                            <span class="text-danger d-block" v-html="variant.availabilityText"></span>
                                        </span>
                                        <span v-else-if="!variant.isAvailable" style="text-decoration: line-through">
                                            {{ variant.name }}
                                            <span class="text-green-dark d-block" v-html="variant.availabilityText"></span>
                                        </span>
                                        <template v-else>
                                            {{ variant.name }}
                                            <span class="text-warning d-block" v-html="variant.availabilityText"></span>
                                        </template>
                                    </div>
                                    <div class="col-2">
                                        <div
                                            v-if="variant.percentDiscount"
                                            class="badge badge-products badge-sale text-uppercase text-dark d-inline text-center px-1 fs-12 fwb d-block ml-xl-0 text-nowrap"
                                        >
                                            -{{ variant.percentDiscount }}%
                                        </div>
                                    </div>
                                    <div class="col-3 text-right text-nowrap notranslate" v-html="$formatCurrency(variant.price)" />
                                </nuxt-link>
                            </div>
                        </div>
                    </template>
                </div>
            </template>
        </div>
    </div>
</template>

<script lang="ts">
import { PropType } from 'vue'
import { GtmEcommerceEventTypeEnum } from '~/models/DataLayer/GtmEcommerceEventTypeEnum'
import GtmEcommerceEvent from '~/models/DataLayer/GtmEcommerceEvent'
import DataLayer from '~/extensions/DataLayer'
import FullProduct from '~/models/Product/FullProduct'
import Variant from '~/models/Product/Variant'
import ProductVariantGroup from '~/models/Product/ProductVariantGroup'

export default {
    props: {
        product: {
            type: Object as PropType<FullProduct>,
            required: true,
        },
    },

    data() {
        return {
            variantGroups: this.product.productVariants.variantGroups,
            isAtLeastOneOpen: false,
            cssClass: 'variant-dropdown__container--shown',
        }
    },

    computed: {
        moreSelect() {
            let status = false
            let select = 0

            this.variantGroups.forEach((variantGroup: ProductVariantGroup) => {
                if (variantGroup.type === 'select') {
                    select++
                    if (select > 1) {
                        status = true
                    }
                }
            })

            return status
        },
    },

    mounted() {
        const cssClass = 'variant-dropdown__container--shown'

        const containers = document.getElementsByClassName('js-variant-dropdown-container')
        const dropdowns = document.getElementsByClassName('js-variant-dropdown')

        const dropdownsArray = [...dropdowns]
        const containersArray = [...containers]

        window.addEventListener('click', ({ target }) => {
            if (!this.isAtLeastOneOpen) {
                return
            }

            let remove = true
            dropdownsArray.forEach((dropdown) => {
                if (dropdown.contains(target as HTMLElement)) {
                    remove = false
                }
            })

            if (remove) {
                this.isAtLeastOneOpen = false
                containersArray.forEach((container) => {
                    container.classList.remove(cssClass)
                })
                const titles = document.getElementsByClassName('variant-dropdown__title')
                const titlesArray = [...titles]
                titlesArray.forEach((title) => {
                    title.classList.add('variant-dropdown__title--show')
                })
            }
        })
    },

    methods: {
        openDropdown(e: Event) {
            const element = e.currentTarget as HTMLElement | null
            if (!element) {
                return
            }

            // close before open selects
            const dropdowns = document.getElementsByClassName(this.cssClass)
            const dropdownsArray = [...dropdowns]
            dropdownsArray.forEach((dropdown) => {
                dropdown.classList.remove(this.cssClass)
            })

            // disable other labels select
            const titles = document.getElementsByClassName('variant-dropdown__title--show')
            const titlesArray = [...titles]
            titlesArray.forEach((title) => {
                title.classList.remove('variant-dropdown__title--show')
            })

            const parentElement = element.parentElement
            if (!parentElement) {
                return
            }

            // set active actual title
            const title = parentElement.previousElementSibling
            title?.classList.add('variant-dropdown__title--show')

            // open select
            const container = parentElement.querySelector('.js-variant-dropdown-container')
            container?.classList.toggle(this.cssClass)
            this.isAtLeastOneOpen = true
        },

        triggerSelectItemEvent(variant: Variant, listPosition: number): void {
            const { product } = this
            const variantProduct = {
                ...product,
                name: variant.productName,
                id: variant.productId,
            }

            const ecommerceEvent = {
                type: GtmEcommerceEventTypeEnum.ClickToProductDetail,
                products: [transformProductToGtmProduct(variantProduct)],
                targetListPosition: listPosition,
                itemListName: 'variants',
            } as GtmEcommerceEvent

            DataLayer.pushEcommerceEventToDataLayer(ecommerceEvent)
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../../node_modules/bootstrap/scss/functions';
@import '../../node_modules/bootstrap/scss/variables';
@import '../../node_modules/bootstrap/scss/mixins';

$border-radius: 10px;

.variant-dropdown {
    position: relative;
    font-size: 14px;

    &__trigger {
        border: 1px solid $color-grey-dark;
        padding: 0 11px;
        border-radius: $border-radius;
        min-height: 45px;

        &:hover {
            border-color: $color-purple;
        }

        .ico-arrow {
            margin-bottom: 4px;
            margin-right: 5px;
        }
    }

    &__image {
        max-height: 35px;
        max-width: 75%;
    }

    &__container {
        display: none;
        border: 1px solid $color-grey-dark;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        z-index: 9;
        box-shadow: $box-shadow;
        border-radius: $border-radius;
        background: $color-white;
        max-height: 400px;

        @media (min-width: 1200px) {
            right: auto;
            width: 352px;
        }

        &--scroll {
            overflow-y: scroll;
            height: 160px;

            @media (min-width: 1024px) {
                height: 180px;
            }
        }

        &--shown {
            display: block;
        }
    }

    &__item {
        padding: 11px;
        color: $color-dark;
        text-decoration: none;

        &:hover {
            background: $color-grey;
            color: $color-dark;
        }

        &--active {
            background: $color-grey;
        }
    }

    &__title {
        @media (min-width: 1200px) {
            opacity: 0.3;
        }

        &--show,
        &--normal {
            @media (min-width: 1200px) {
                opacity: 1;
            }
        }
    }
}

.variant-image {
    width: 43px;
    border-radius: $border-radius;
    padding: 1px;
    border: 1px solid transparent;
    margin-right: 6px;

    &--active {
        border-color: $color-cta;
    }
}

.variant-radio {
    border-radius: $border-radius;
    padding: 10px 12px;
    border: 1px solid $color-grey-dark;
    text-decoration: none;
    color: $color-dark;
    margin: 1px 10px 10px 1px;
    display: inline-block;

    &--active {
        border: 2px solid $color-purple;
        color: $color-dark;
        margin: 0 9px 9px 0;
    }

    &:hover {
        @include media-breakpoint-up(md) {
            border: 2px solid $color-purple;
            color: $color-dark;
            margin: 0 9px 9px 0;
        }
    }
}

@media (min-width: 1200px) {
    .variant-dropdown--large:nth-child(2) .variant-dropdown__container {
        left: auto;
        right: 0;
    }
}
</style>
